import { t } from '@lingui/core/macro';
import type { ComponentProps } from 'react';

import DotsHorizontalIcon from '@/assets/svg/bx-dots-horizontal-rounded.svg?react';
import { cn } from '@/lib/utils';

export type PaginationEllipsisProps = ComponentProps<'span'>;

const PaginationEllipsis = ({ className, ...props }: PaginationEllipsisProps) => {
  return (
    <span
      aria-hidden
      data-slot="pagination-ellipsis"
      className={cn(
        "flex size-8 items-center justify-center [&_svg:not([class*='size-'])]:size-4",
        className,
      )}
      {...props}
    >
      <DotsHorizontalIcon />
      <span className="sr-only">{t`More pages`}</span>
    </span>
  );
};

export default PaginationEllipsis;
